import request from '@/utils/request'

//Load Direct Sponsored List
export function loadPaginatedDirectSponsor(params) {
  return request({ url: 'vdirectsponsorslist', method: 'post', data: params })
} 